import { createAction, props } from '@ngrx/store';
import { ISpecialLabelOptions } from '../states/special-features';

const actionPrefix = '[Dashboard] [Special Features]';

const setIsShelfReportActive = createAction(
  `${actionPrefix} Set Shelf Report Active Status`,
  props<{ isShelfReportActive: boolean; shopId: number }>(),
);

const setIsSpecialLabelActive = createAction(
  `${actionPrefix} Set Special Label Active Status`,
  props<{ isSpecialLabelActive: boolean; shopId: number }>(),
);

const setSpecialLabelOptions = createAction(
  `${actionPrefix} Set Special Label Options`,
  props<Partial<ISpecialLabelOptions> & { shopId: number }>(),
);

const setIsScanOrdersActive = createAction(
  `${actionPrefix} Set Scan Orders Active Status`,
  props<{ isScanOrdersActive: boolean; shopId: number }>(),
);

const downloadSlaAccountabilityReport = createAction(
  `${actionPrefix} Download SLA Accountability Report`,
  props<{ shopId: number; start: string; end: string }>(),
);

const downloadDeliveryPromiseAccountabilityReport = createAction(
  `${actionPrefix} Download Delivery Promise Accountability Report`,
  props<{ shopId: number }>(),
);

const toggleFieldsToActions = {
  isShelfReportActive: setIsShelfReportActive,
  isScanOrdersActive: setIsScanOrdersActive,
};

export {
  setIsShelfReportActive,
  setIsSpecialLabelActive,
  setSpecialLabelOptions,
  setIsScanOrdersActive,
  downloadSlaAccountabilityReport,
  downloadDeliveryPromiseAccountabilityReport,
  toggleFieldsToActions,
};
